export default function () {
var Audioteka = Audioteka || {};
(function () {
    if (typeof String.prototype.trim !== 'function') {
        String.prototype.trim = function () {
            return this.replace(/^\s+|\s+$/g, '');
        }
    }
    var indexOf = function (obj) {
        if (typeof Array.prototype.indexOf === 'function') {
            indexOf = Array.prototype.indexOf;
        } else {
            indexOf = function (obj) {
                var i, index = -1;
                for (i = 0; i < this.length; i++) {
                    if (this[i] === obj) {
                        index = i;
                        break;
                    }
                }
                return index;
            };
        }
        return indexOf.call(this, obj);
    };
    var jQuery, isSoundManagerScriptLoaded = false, isJQueryScriptLoaded = false, projectUrl = '';

    // function findProjectPath(name) {
    //     var scripts = document.getElementsByTagName('script');
    //     for (var i = scripts.length - 1; i >= 0; --i) {
    //         var src = scripts[i].src;
    //         var l = src.length;
    //         var length = name.length;
    //         if (src.substr(l - length) == name) {
    //             projectUrl = src.substr(0, l - length);
    //             break;
    //         }
    //     }
    // }

    // findProjectPath('js/sample-player.js');
    // if (projectUrl == '') {
    //     findProjectPath('js/sample-player.min.js');
    // }
    Audioteka.SamplePlayer = {
        isSoundManagerReady: false,
        isSoundManagerInitStart: false,
        soundIDs: [],
        addSampleDefaultOptions: {
            containerSelector: '.audioteka-sample-player',
            withTimeLabel: false,
            customHtmlStructure: false,
            playingCssClass: 'is-playing',
            btnPlayCssClass: 'audioteka-sample-player_btn-play',
            btnPauseCssClass: 'audioteka-sample-player_btn-pause',
            timeLabelCssClass: 'audioteka-sample-player_lbl-time'
        },
        initSoundManager: function () {
            var _this = this;
            _this.isSoundManagerInitStart = true;
            var i = 0;
            var sm2ScriptsCheckInitInterval = setInterval(function () {
                i++;
                if (i > 20) {
                    clearInterval(sm2ScriptsCheckInitInterval);
                }
                else if (isSoundManagerScriptLoaded) {
                    clearInterval(sm2ScriptsCheckInitInterval);
                    soundManager.setup({
                        url: projectUrl + "js/swf/",
                        flashVersion: 9,
                        useFlashBlock: false,
                        preferFlash: false,
                        onready: function () {
                            _this.isSoundManagerReady = true;
                        },
                        ontimeout: function () {
                            _this.initSoundManager();
                        },
                        defaultOptions: {}
                    });
                }
            }, 200);
        },
        addSample: function (opts) {
            var _this = this;
            var i = 0;
            var jqScriptsCheckInitInterval = setInterval(function () {
                i++;
                if (i > 20) {
                    clearInterval(jqScriptsCheckInitInterval);
                }
                else if (isJQueryScriptLoaded) {
                    clearInterval(jqScriptsCheckInitInterval);
                    var options = jQuery.extend({}, _this.addSampleDefaultOptions, opts);
                    if (options.containerSelector !== null) {
                        jQuery(options.containerSelector).each(function () {
                            var $this = jQuery(this), mp3Path = $this.attr('data-mp3');
                            if ((mp3Path !== undefined) && (mp3Path !== null) && (mp3Path.trim() !== '')) {
                                var sound, soundId = _this.getSoundIdFromMp3Path(mp3Path);
                                if (!$this.attr('data-has-sample-player')) {
                                    var btnPlay, btnPause, lblTime = null;
                                    if (options.customHtmlStructure) {
                                        if ((options.btnPlayCssClass.trim() !== '') && (options.btnPauseCssClass.trim() !== '')) {
                                            btnPlay = jQuery('.' + options.btnPlayCssClass, $this);
                                            btnPause = jQuery('.' + options.btnPauseCssClass, $this);
                                            if (options.withTimeLabel && (options.timeLabelCssClass.trim() !== '')) {
                                                lblTime = jQuery('.' + options.timeLabelCssClass, $this);
                                                _this.resetTimeLabel(lblTime);
                                            }
                                            $this.attr('data-has-sample-player', 'true');
                                        }
                                    }
                                    else {
                                        btnPlay = jQuery(_this.getBtnPlayHtmlTemplate());
                                        btnPause = jQuery(_this.getBtnPauseHtmlTemplate());
                                        $this.append(btnPlay);
                                        $this.append(btnPause);
                                        if (options.withTimeLabel) {
                                            lblTime = jQuery(_this.getTimeLabelHtmlTemplate());
                                            $this.append(lblTime);
                                        }
                                        $this.attr('data-has-sample-player', 'true');
                                    }
                                    btnPlay.bind('click', function (e) {
                                        e.preventDefault();
                                        soundManager.pauseAll();
                                        sound = soundManager.getSoundById(soundId);
                                        if (sound === undefined) {
                                            sound = soundManager.createSound({
                                                id: soundId,
                                                url: mp3Path,
                                                autoPlay: true,
                                                onpause: function () {
                                                    _this.unmarkPlayingContainer($this, options.playingCssClass);
                                                },
                                                onfinish: function () {
                                                    _this.unmarkPlayingContainer($this, options.playingCssClass);
                                                    if (lblTime !== null) {
                                                        _this.resetTimeLabel(lblTime);
                                                    }
                                                },
                                                whileplaying: function () {
                                                    if (lblTime !== null) {
                                                        lblTime.html(_this.getTimeLabelFromMiliseconds(sound.position));
                                                    }
                                                }
                                            });
                                        }
                                        else {
                                            sound.play();
                                        }
                                        _this.markPlayingContainer($this, options.playingCssClass);
                                    });
                                    btnPause.bind('click', function (e) {
                                        e.preventDefault();
                                        soundManager.pause(soundId);
                                    });
                                }
                            }
                        });
                    }
                }
            }, 200);
        },
        getBtnPlayHtmlTemplate: function () {
            return '<span class="' + Audioteka.SamplePlayer.addSampleDefaultOptions.btnPlayCssClass + '"></span>';
        },
        getBtnPauseHtmlTemplate: function () {
            return '<span class="' + Audioteka.SamplePlayer.addSampleDefaultOptions.btnPauseCssClass + '"></span>';
        },
        getTimeLabelHtmlTemplate: function () {
            return '<span class="' + Audioteka.SamplePlayer.addSampleDefaultOptions.timeLabelCssClass + '">0:00</span>';
        },
        resetTimeLabel: function (lblTime) {
            lblTime.html('0:00');
        },
        getTimeLabelFromMiliseconds: function (ms) {
            var timeLabel = '', seconds = (ms / 1000), h = Math.floor(seconds / 3600), m = Math.floor(seconds % 3600 / 60), s = Math.floor(seconds % 3600 % 60);
            if (h > 0) {
                timeLabel += h + ':';
            }
            if (m > 0) {
                if (h > 0 && m < 10) {
                    timeLabel += '0';
                }
                timeLabel += m + ':';
            }
            else {
                timeLabel += '0:';
            }
            if (s > 0) {
                if (s < 10) {
                    timeLabel += '0';
                }
                timeLabel += s;
            }
            else {
                timeLabel += '00';
            }
            return timeLabel;
        },
        markPlayingContainer: function (container, cssClass) {
            container.addClass(cssClass);
        },
        unmarkPlayingContainer: function (container, cssClass) {
            container.removeClass(cssClass);
        },
        getSoundIdFromMp3Path: function (mp3Path) {
            var soundId = mp3Path;
            while (indexOf.call(Audioteka.SamplePlayer.soundIDs, soundId) != -1) {
                soundId += '_';
            }
            Audioteka.SamplePlayer.soundIDs.push(soundId);
            return soundId;
        }
    };
    // if (window.jQuery === undefined) {
    //     loadScript("//code.jquery.com/jquery-1.11.0.min.js", jQueryScriptLoadHandler);
    // } else {
    //     isJQueryScriptLoaded = true;
    //     jQuery = window.jQuery;
    //     init();
    // }
    // loadScript(projectUrl + "js/soundmanager2-nodebug-jsmin.js", soundManagerScriptLoadHandler);
    isJQueryScriptLoaded = true;
    jQuery = window.jQuery;
    init();
    isSoundManagerScriptLoaded = true;
    function jQueryScriptLoadHandler() {
        isJQueryScriptLoaded = true;
        jQuery = window.jQuery.noConflict(true);
        init();
    }

    function soundManagerScriptLoadHandler() {
        isSoundManagerScriptLoaded = true;
    }

    function loadScript(sURL, onLoad) {
        function loadScriptHandler() {
            var rs = this.readyState;
            if (rs == 'loaded' || rs == 'complete') {
                this.onreadystatechange = null;
                this.onload = null;
                if (onLoad) {
                    onLoad();
                }
            }
        }

        function scriptOnload() {
            this.onreadystatechange = null;
            this.onload = null;
            window.setTimeout(onLoad, 20);
        }

        var oS = document.createElement('script');
        oS.type = 'text/javascript';
        if (onLoad) {
            oS.onreadystatechange = loadScriptHandler;
            oS.onload = scriptOnload;
        }
        oS.src = sURL;
        document.getElementsByTagName('head')[0].appendChild(oS);
    }

    function init() {
        // jQuery(document).ready(function ($) {
        //     var css_link = $("<link>", {
        //         rel: "stylesheet",
        //         type: "text/css",
        //         href: projectUrl + "css/sample-player.css"
        //     });
        //     css_link.appendTo('head');
        // });
        if (!Audioteka.SamplePlayer.isSoundManagerReady && !Audioteka.SamplePlayer.isSoundManagerInitStart) {
            Audioteka.SamplePlayer.initSoundManager();
        }
    }
})();

Audioteka.SamplePlayer.addSample({
    containerSelector: '.sample-player',
    withTimeLabel: true,
    customHtmlStructure: true,
    btnPlayCssClass: 'btn-play',
    btnPauseCssClass: 'btn-pause',
    timeLabelCssClass: 'time-lbl'
});

}